(function () {
  var TOOL_SELECTOR = '[data-tms-tool="wood-movement"]';

  var SPECIES_DATA = {
    "white-oak": { label: "White Oak", tangential: 0.00338, radial: 0.00180 },
    "red-oak": { label: "Red Oak", tangential: 0.00396, radial: 0.00165 },
    "walnut": { label: "Walnut", tangential: 0.00274, radial: 0.00194 },
    "hard-maple": { label: "Hard Maple", tangential: 0.00353, radial: 0.00171 },
    "soft-maple": { label: "Soft Maple", tangential: 0.00310, radial: 0.00170 },
    "cherry": { label: "Cherry", tangential: 0.00248, radial: 0.00141 },
    "ash": { label: "Ash", tangential: 0.00274, radial: 0.00159 },
    "beech": { label: "Beech", tangential: 0.00420, radial: 0.00202 },
    "teak": { label: "Teak", tangential: 0.00250, radial: 0.00140 },
    "douglas-fir": { label: "Douglas Fir", tangential: 0.00267, radial: 0.00171 },
    "pine": { label: "Pine", tangential: 0.00234, radial: 0.00145 },
    "western-red-cedar": { label: "Western Red Cedar", tangential: 0.00234, radial: 0.00150 },
    "custom": { label: "Custom coefficient", tangential: null, radial: null }
  };

  var SERVICE_CONDITIONS = {
    "heated-interior": { label: "Heated / air-conditioned interior", mc: 7 },
    "typical-interior": { label: "Typical interior space", mc: 9 },
    "humid-interior": { label: "Humid interior / coastal interior", mc: 11 },
    "workshop": { label: "Unconditioned workshop / garage", mc: 13 },
    "covered-outdoor": { label: "Covered outdoor environment", mc: 15 }
  };

  function initAll(scope) {
    var root = scope || document;
    var tools = root.querySelectorAll(TOOL_SELECTOR);

    tools.forEach(function (tool) {
      if (tool.dataset.tmsInitialized === "true") {
        return;
      }
      tool.dataset.tmsInitialized = "true";
      initTool(tool);
    });
  }

  function initTool(tool) {
    var species = tool.querySelector("#tmsWmSpecies");
    var cut = tool.querySelector("#tmsWmCut");
    var width = tool.querySelector("#tmsWmWidth");
    var inputUnit = tool.querySelector("#tmsWmInputUnit");
    var widthUnitText = tool.querySelector("#tmsWmWidthUnitText");
    var customRateWrap = tool.querySelector("#tmsWmCustomRateWrap");
    var customRate = tool.querySelector("#tmsWmCustomRate");
    var startMc = tool.querySelector("#tmsWmStartMc");
    var endMc = tool.querySelector("#tmsWmEndMc");
    var fromCondition = tool.querySelector("#tmsWmFromCondition");
    var toCondition = tool.querySelector("#tmsWmToCondition");
    var calculateBtn = tool.querySelector("#tmsWmCalculate");
    var resetBtn = tool.querySelector("#tmsWmReset");
    var message = tool.querySelector("#tmsWmMessage");
    var resultCard = tool.querySelector("#tmsWmResultCard");
    var emptyState = tool.querySelector("#tmsWmEmptyState");
    var resultContent = tool.querySelector("#tmsWmResultContent");
    var movementValue = tool.querySelector("#tmsWmMovementValue");
    var directionText = tool.querySelector("#tmsWmDirectionText");
    var startWidthEl = tool.querySelector("#tmsWmStartWidth");
    var endWidthEl = tool.querySelector("#tmsWmEndWidth");
    var mcChangeEl = tool.querySelector("#tmsWmMcChange");
    var rateValueEl = tool.querySelector("#tmsWmRateValue");
    var practicalTextEl = tool.querySelector("#tmsWmPracticalText");
    var modeButtons = tool.querySelectorAll(".tms-wm-mode-btn");
    var modePanels = tool.querySelectorAll(".tms-wm-mode-panel");
    var sourceToggle = tool.querySelector("#tmsWmSourceToggle");
    var sourceContent = tool.querySelector("#tmsWmSourceContent");
    var sourceIcon = tool.querySelector("#tmsWmSourceIcon");

    var currentMode = "moisture";

    function setMode(mode) {
      currentMode = mode;

      modeButtons.forEach(function (btn) {
        var active = btn.getAttribute("data-mode") === mode;
        btn.classList.toggle("is-active", active);
        btn.setAttribute("aria-pressed", active ? "true" : "false");
      });

      modePanels.forEach(function (panel) {
        panel.classList.toggle("is-active", panel.getAttribute("data-mode-panel") === mode);
      });
    }

    function updateCustomRateVisibility() {
      customRateWrap.hidden = species.value !== "custom";
    }

    function updateInputUnitLabel() {
      widthUnitText.textContent = inputUnit.value;
    }

    function showMessage(type, text) {
      if (!text) {
        message.className = "tms-wm-message";
        message.textContent = "";
        return;
      }

      message.className = "tms-wm-message is-visible " + (type === "error" ? "is-error" : "is-success");
      message.textContent = text;
    }

    function toInches(value, unit) {
      return unit === "cm" ? value / 2.54 : value;
    }

    function inchesToCm(value) {
      return value * 2.54;
    }

    function formatDualLength(inchesValue) {
      return inchesValue.toFixed(3) + " in / " + inchesToCm(inchesValue).toFixed(2) + " cm";
    }

    function getCoefficient() {
      if (species.value === "custom") {
        var custom = parseFloat(customRate.value);
        if (isNaN(custom) || custom <= 0) {
          return null;
        }
        return custom;
      }

      var config = SPECIES_DATA[species.value];
      if (!config) {
        return null;
      }

      return cut.value === "quarter" ? config.radial : config.tangential;
    }

    function getMoistureData() {
      if (currentMode === "moisture") {
        var start = parseFloat(startMc.value);
        var end = parseFloat(endMc.value);

        if (isNaN(start) || isNaN(end)) {
          return null;
        }

        return {
          startMc: start,
          endMc: end,
          contextLabel: "Direct moisture-content comparison"
        };
      }

      var fromData = SERVICE_CONDITIONS[fromCondition.value];
      var toData = SERVICE_CONDITIONS[toCondition.value];

      if (!fromData || !toData) {
        return null;
      }

      return {
        startMc: fromData.mc,
        endMc: toData.mc,
        contextLabel: fromData.label + " to " + toData.label
      };
    }

    function validateInputs(coefficient, widthValueRaw, moistureData) {
      if (!coefficient || isNaN(coefficient) || coefficient <= 0) {
        return "Please select a wood species or enter a valid custom coefficient.";
      }

      if (isNaN(widthValueRaw) || widthValueRaw <= 0) {
        return "Please enter a valid board width greater than zero.";
      }

      if (!moistureData) {
        return currentMode === "moisture"
          ? "Please enter both starting and ending moisture content values."
          : "Please choose both service conditions.";
      }

      if (
        moistureData.startMc < 1 ||
        moistureData.startMc > 30 ||
        moistureData.endMc < 1 ||
        moistureData.endMc > 30
      ) {
        return "Moisture-content values should normally be between 1% and 30%.";
      }

      return "";
    }

    function buildPracticalText(payload) {
      var absMovement = Math.abs(payload.movementIn);
      var trendWord = payload.movementIn > 0 ? "expand" : payload.movementIn < 0 ? "shrink" : "stay about the same size";
      var guidance = "";

      if (absMovement < 0.03) {
        guidance = "This is relatively small movement, but tight trapped details can still create stress over time.";
      } else if (absMovement < 0.08) {
        guidance = "This is noticeable movement. Small clearances, elongated holes, or flexible fixing details are worth planning.";
      } else if (absMovement < 0.15) {
        guidance = "This is meaningful movement. Avoid locking the board rigidly across the grain.";
      } else {
        guidance = "This is large seasonal movement. Wide solid-wood parts should be allowed to move with slots, clips, floating panels, or other movement-friendly details.";
      }

      return "For a board " + payload.startWidthIn.toFixed(3) + " inches wide (" + inchesToCm(payload.startWidthIn).toFixed(2) + " cm), the estimate suggests it may " + trendWord + " by about " + payload.absMovementText + " across its width. " + guidance + " Basis used: " + payload.contextLabel + ".";
    }

    function renderResult(payload) {
      resultCard.classList.remove("is-empty");
      emptyState.hidden = true;
      resultContent.hidden = false;

      movementValue.textContent = payload.absMovementText;
      directionText.textContent = payload.directionSentence;
      startWidthEl.textContent = formatDualLength(payload.startWidthIn);
      endWidthEl.textContent = formatDualLength(payload.endWidthIn);
      mcChangeEl.textContent = payload.deltaMc.toFixed(1) + "%";
      rateValueEl.textContent = payload.coefficient.toFixed(5);
      practicalTextEl.textContent = payload.practicalText;
    }

    function clearResult() {
      resultCard.classList.add("is-empty");
      emptyState.hidden = false;
      resultContent.hidden = true;

      movementValue.textContent = "0.000 in / 0.00 cm";
      directionText.textContent = "";
      startWidthEl.textContent = "0.000 in / 0.00 cm";
      endWidthEl.textContent = "0.000 in / 0.00 cm";
      mcChangeEl.textContent = "0.0%";
      rateValueEl.textContent = "0.00000";
      practicalTextEl.textContent = "";
    }

    function calculate() {
      showMessage("", "");

      var widthValueRaw = parseFloat(width.value);
      var widthIn = toInches(widthValueRaw, inputUnit.value);
      var coefficient = getCoefficient();
      var moistureData = getMoistureData();
      var validationError = validateInputs(coefficient, widthValueRaw, moistureData);

      if (validationError) {
        clearResult();
        showMessage("error", validationError);
        return;
      }

      var deltaMc = moistureData.endMc - moistureData.startMc;
      var movementIn = widthIn * coefficient * deltaMc;
      var endWidthIn = widthIn + movementIn;
      var directionSentence = "";

      if (movementIn > 0) {
        directionSentence = "The board is expected to expand as moisture rises.";
      } else if (movementIn < 0) {
        directionSentence = "The board is expected to shrink as moisture drops.";
      } else {
        directionSentence = "No width change is expected because both moisture values are the same.";
      }

      var payload = {
        movementIn: movementIn,
        startWidthIn: widthIn,
        endWidthIn: endWidthIn,
        deltaMc: Math.abs(deltaMc),
        coefficient: coefficient,
        contextLabel: moistureData.contextLabel,
        absMovementText: formatDualLength(Math.abs(movementIn)),
        directionSentence: directionSentence
      };

      payload.practicalText = buildPracticalText(payload);

      renderResult(payload);
      showMessage("success", "Estimated movement calculated successfully.");
    }

    function resetTool() {
      species.value = "white-oak";
      cut.value = "flat";
      width.value = "";
      inputUnit.value = "in";
      customRate.value = "";
      startMc.value = "";
      endMc.value = "";
      fromCondition.value = "heated-interior";
      toCondition.value = "typical-interior";
      setMode("moisture");
      updateCustomRateVisibility();
      updateInputUnitLabel();
      clearResult();
      showMessage("", "");
    }

    species.addEventListener("change", updateCustomRateVisibility);
    inputUnit.addEventListener("change", updateInputUnitLabel);

    modeButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        setMode(btn.getAttribute("data-mode"));
        showMessage("", "");
      });
    });

    calculateBtn.addEventListener("click", calculate);
    resetBtn.addEventListener("click", resetTool);

    if (sourceToggle && sourceContent && sourceIcon) {
      sourceToggle.addEventListener("click", function () {
        var expanded = sourceToggle.getAttribute("aria-expanded") === "true";
        sourceToggle.setAttribute("aria-expanded", expanded ? "false" : "true");
        sourceContent.hidden = expanded;
        sourceIcon.textContent = expanded ? "+" : "-";
      });
    }

    updateCustomRateVisibility();
    updateInputUnitLabel();
    clearResult();
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAll(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });

  document.addEventListener("shopify:section:reorder", function (event) {
    initAll(event.target);
  });
})();